import React from 'react';
import { MotionBox } from './motion';

const Reveal = ({ children, delay = 0, y = 28, duration = 0.7, ...props }) => (
  <MotionBox
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
    {...props}
  >
    {children}
  </MotionBox>
);

export default Reveal;
